module.exports = __webpack_public_path__ + "static/img/ziyou03.effcb34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ziyou03.png
// module id = rNAk
// module chunks = 1